import { render, staticRenderFns } from "./SelectCustom.vue?vue&type=template&id=09fd8096&scoped=true"
import script from "./SelectCustom.vue?vue&type=script&lang=js"
export * from "./SelectCustom.vue?vue&type=script&lang=js"
import style0 from "./SelectCustom.vue?vue&type=style&index=0&id=09fd8096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd8096",
  null
  
)

export default component.exports